import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, CheckSquareIcon, HeadphonesIcon, CalendarIcon, SunIcon, CheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
const packItems = [{
  icon: BookOpenIcon,
  text: 'Ebook en PDF imprimible'
}, {
  icon: SunIcon,
  text: 'Rutinas estructuradas día y noche'
}, {
  icon: CheckSquareIcon,
  text: 'Checklists de seguimiento'
}, {
  icon: HeadphonesIcon,
  text: 'Audio de acompañamiento'
}, {
  icon: CalendarIcon,
  text: 'Ruta guiada de 6 semanas'
}];
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="acceder" className="py-20 md:py-28 px-4 bg-gradient-to-b from-navy via-[#1e2f50] to-[#0f1a2e] text-white" data-id="element-106">
      <div ref={ref} className="max-w-5xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-108">
          <h2 className="font-serif text-3xl md:text-5xl mb-6" data-id="element-109">
            Accede hoy al método Noches Secas
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-110">
            Un método completo, pensado para familias reales que necesitan
            orden, acompañamiento y claridad. No es un consejo suelto: es una
            guía paso a paso que puedes aplicar en casa, respetando el ritmo de
            tu hijo y la calma de toda la familia.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-10 items-center mb-14" data-id="element-111">
          {/* Product mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="flex justify-center" data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/tEiwUDpUwTSy8CX73r8GUS/1._MOCKUP_NOCHES_SECAS.png" alt="Pack completo Noches Secas: ebook, tablet y audio" className="w-full max-w-md h-auto" data-id="element-113" />
          </motion.div>

          {/* Pack contents + price */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.3,
          duration: 0.5
        }} data-id="element-114">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8" data-id="element-115">
              <h3 className="font-serif text-2xl mb-6 text-gold" data-id="element-116">
                Tu acceso incluye
              </h3>

              <ul className="space-y-4 mb-8" data-id="element-117">
                {packItems.map((item, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: 15
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                delay: 0.4 + index * 0.08
              }} className="flex items-center gap-3" data-id="element-118">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gold/15 flex items-center justify-center" data-id="element-119">
                      <item.icon className="w-4 h-4 text-gold" data-id="element-120" />
                    </span>
                    <span className="text-white/90" data-id="element-121">{item.text}</span>
                  </motion.li>)}
              </ul>

              <p className="text-white/60 text-sm mb-8 italic" data-id="element-122">
                Todo lo que necesitas para acompañar este proceso con calma,
                respeto y método.
              </p>

              {/* Price */}
              <motion.div initial={{
              opacity: 0,
              y: 15
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              delay: 0.7
            }} className="border-t border-white/10 pt-6 mb-6" data-id="element-123">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-124">
                  <span className="font-serif text-5xl text-gold" data-id="element-125">6,50</span>
                  <span className="text-2xl text-gold/80" data-id="element-126">€</span>
                </div>
                <p className="text-white/60 text-sm" data-id="element-127">
                  Acceso digital inmediato. Pago único. Sin suscripciones.
                </p>
              </motion.div>

              {/* CTA */}
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              delay: 0.8
            }} data-id="element-128">
                <Button href="https://go.hotmart.com/W104285887H?dp=1" className="w-full text-center text-lg py-4" data-id="element-129">
                  Acceder ahora al método Noches Secas
                </Button>
              </motion.div>
            </div>
          </motion.div>
        </div>

        {/* Trust closing line */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.9
      }} className="text-center text-white/50 text-sm max-w-xl mx-auto" data-id="element-130">
          Recibirás acceso inmediato a todo el contenido digital tras completar
          tu compra de forma segura.
        </motion.p>
      </div>
    </section>;
}